import { render, staticRenderFns } from "./DatepickerCustomDialog.vue?vue&type=template&id=5ea75968&scoped=true&"
import script from "./DatepickerCustomDialog.vue?vue&type=script&lang=js&"
export * from "./DatepickerCustomDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ea75968",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDatePicker } from 'vuetify/lib/components/VDatePicker';
import { VDialog } from 'vuetify/lib/components/VDialog';
installComponents(component, {VDatePicker,VDialog})
